/* eslint-disable consistent-return */
import PropTypes from 'prop-types';
import { Button } from 'ypf-pas-general-ui-components';
import { BsPencil } from 'react-icons/bs';

import { useWorkReportModals } from '../../../context/WorkReportModalsContext';
import { partesTrabajoDiarioItemsWorkReport } from '../../../utils/globalPropTypes';
import { checkRol } from '../../../security';
import { inspector } from '../../../security/constantsRols';
import ComponentWithTooltip from '../../ComponentWithTooltip/ComponentWithTooltip';

import styles from './EditButton.module.scss';

/**
 * @typedef Props
 * @property {(action: import('../../WeeklyReportTable/reducer/optimisticUIReducer').OptimisticUIActions) => void} handleChangedActions
 * @property {OptimisticUIState} changedActions
 */

/** @param {Props} */
const EditButton = ({ dailyWorkReport, selectedDate, fetchData, handleChangedActions }) => {
  const { activeEditQuantityModal } = useWorkReportModals();

  const isInspector = checkRol(inspector);

  /** @param {{isCancel: boolean, newQuantity: number}} */
  const fetchDataWithDefaultParams = ({ isCancel, newQuantity }) => {
    fetchData();

    if (!isInspector) {
      handleChangedActions({ type: 'approver.fixed', payload: newQuantity });
      handleChangedActions({ type: 'inspector.revision' });

      return;
    }

    if (isCancel) return handleChangedActions({ type: 'inspector.rejected' });

    handleChangedActions({ type: 'approver.fixed', payload: newQuantity });
    handleChangedActions({ type: 'inspector.sentToSE' });
  };

  const keys = Object.keys(dailyWorkReport);
  // eslint-disable-next-line no-nested-ternary
  const disableValue = keys.includes('editaAprobador')
    ? !dailyWorkReport?.editaAprobador
    : keys.includes('rectificaCantidad')
    ? !dailyWorkReport?.rectificaCantidad
    : true;

  return (
    <ComponentWithTooltip id="hidden-tooltip" tooltipText="Editar">
      <div className={`d-flex justify-content-evenly ${styles.container}`}>
        <Button
          className={`mx-1 ${styles['button-with-tooltip']}`}
          colorIcon="dark"
          disabled={disableValue}
          icon={BsPencil}
          onClick={() => {
            activeEditQuantityModal(
              {
                ...{
                  ...dailyWorkReport,
                  tienePuntosPrograma: dailyWorkReport?.tienePuntosPrograma
                },
                date: selectedDate,
                viewCSA: true,
                editCSA: true,
                defaultValue: true
              },
              fetchDataWithDefaultParams
            );
          }}
          type="button"
          variant="light"
          widthButton="30px"
        />
      </div>
    </ComponentWithTooltip>
  );
};

export default EditButton;

EditButton.propTypes = {
  dailyWorkReport: partesTrabajoDiarioItemsWorkReport,
  fetchData: PropTypes.func,
  handleChangedActions: PropTypes.func,
  selectedDate: PropTypes.string
};

EditButton.defaultProps = {
  dailyWorkReport: {},
  handleChangedActions: () => {},
  selectedDate: '',
  fetchData: () => {}
};
